export const es = {
    LEFT: 'A la izquierda: Mover a la del día anterior.',
    RIGHT: 'Derecha: Mover al día siguiente.',
    DOWN: 'Abajo: Moverse a la siguiente fila.',
    UP: 'Hasta: Mover a la fila anterior.',
    PGUP: 'Repág: Mover a la del mes anterior.',
    PGDOWN: 'Avpág: ir al siguiente mes.',
    HOME: 'Inicio: Mover a la del año anterior.',
    END: 'Final: pasar al siguiente año.',
    ESC: 'Esc/Hoy/Cerrar: cierra el calendario.',
    TITLE: 'Instrucciones Del Teclado'
};
